import React from 'react'
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { navigate } from 'gatsby'
import { getUser } from '../services/auth'
import { cache, isLoggedInVar } from '../cache'
import { LOGIN_ROUTE } from './routes'
import LocalStorageManager from '../utils/localStorageManager'
import { endSession, findSessionError } from '../utils/session'
import { sentryLink } from '../utils/sentryApolloLink'

const httpLink = createHttpLink({
  uri: process.env.MIDDLE_END_URL,
})

const authLink = setContext((_, { headers }) => {
  const hasToken = !!getUser()?.token
  return {
    headers: {
      ...headers,
      authorization: hasToken ? `Bearer ${getUser().token}` : '',
    },
  }
})
const MAX_FAILED_ATTEMPTS_REASON = 'MAX_FAILED_ATTEMPTS'
const ACCOUNT_BLOCKED_KEY = 'accountBlocked'

const isInactiveUserError = error =>
  error?.extensions?.code === '1000' ||
  error?.extensions?.type === 'INACTIVE_USER'

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const inactiveUserError = graphQLErrors?.find(isInactiveUserError)

  // AD-6550: sesion vencida o invalida -> directo al Login con aviso, en vez
  // de dejar el Home vacio con el menu habilitado. Solo si habia una sesion
  // guardada: una operacion protegida sin sesion no es una sesion expirada.
  if (
    !inactiveUserError &&
    getUser()?.token &&
    findSessionError({ graphQLErrors, networkError })
  ) {
    endSession({ expired: true })
    return
  }

  if (inactiveUserError) {
    isLoggedInVar(null)
    LocalStorageManager.clear()
    LocalStorageManager.setItem('reloaded', 'true')
    if (typeof window !== 'undefined') {
      const blockedByFailedAttempts =
        inactiveUserError.extensions?.reason === MAX_FAILED_ATTEMPTS_REASON
      window.sessionStorage.setItem(
        ACCOUNT_BLOCKED_KEY,
        JSON.stringify({ accountBlocked: true, blockedByFailedAttempts }),
      )
      navigate(LOGIN_ROUTE)
    }
  }
})

const client = new ApolloClient({
  cache,
  link: from([errorLink, authLink, sentryLink, httpLink]),
  name: 'push-money',
})

function Apollo({ children }) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
export default Apollo
